const initialState = {
	productFormFields : [
	    {
		 	type: 'text',
	 		label: 'Explain Your Reason',
	 	 	defaultValue: null,
	 	 	style: { width: '93%', height : "22%" },
	 	 	multiline : true
	 	}	
	],

	orders : [
		{
			order_id : 1,
			unique_order_id : "d2je541aschw215418",
			product_id : 56,
			user_id : 5,
			coupon_name : "LKTMSJD",
			full_address : " 1767 Nelson Mandela Drive 	Pietersburg Limpopo 0814",
			quantity : 2,
			actual_price : "R200",
			applied_price : "R150",
			total_price : "R300",
			payment_mode : "Credit Card",
			transaction_id : "1234552445",
		},
		{
			order_id : 2,
			unique_order_id : "lkutshbdaschw2154115",
			product_id : 46,
			user_id : 9,
			coupon_name : "No coupon applied",
			full_address : "2120 President St Johannesburg Gauteng 2065",
			quantity : 1,
			actual_price : "R120",
			applied_price : "R90",
			total_price : "R300",
			payment_mode : "Credit Card",
			transaction_id : "1234552445",
		}
	]
}

const orderReducer = (state = initialState, action) => {
	switch(action.type){
		default :
			return state ;
	}
}

export default orderReducer ;